import { Controller } from "@hotwired/stimulus"
import { enter, leave } from "../../../../design_system/transitions"

export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this.isOpen = false
  }

  toggle(event) {
    this.isOpen ? this.close(event) : this.open(event)
  }

  open(event) {
    event?.preventDefault()
    this.alignMenuTop()
    enter(this.menuTarget)
    this.isOpen = true
  }

  close(event) {
    event?.preventDefault()
    leave(this.menuTarget)
    this.isOpen = false
  }

  alignMenuTop() {
    const anchor = this.element.closest("[data-secondary-sidebar-anchor]")
    if (!anchor) return

    this.menuTarget.style.top = `${anchor.getBoundingClientRect().bottom + 10}px`
  }
}
